// @flow

import Service from './service';
import type { MemberType } from '../types/member';
import type { ApiConstructorArgsType } from '../types/api';
import type { HttpResponseType } from '../types/http-response';

export default class MemberService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = this.conf.path.serviceBase;
  }

  getMembers(params: Object = {}): Promise<Object> {
    return this.api.get(`${this.baseUrl}/members`, { params, cache: true })
      .then((res) => {
        // Logged out users
        if (res.data.status === 'ERROR') {
          return { ...res.data, members: [] };
        }
        return { status: 'SUCCESS', members: res.data };
      });
  }

  saveMembers(members: Array<MemberType> = []): Promise<Object> {
    if (!members.length) {
      return Promise.reject({ err: 'No members supplied' });
    }
    return this.api.post(`${this.baseUrl}/members`, { members })
      .then(res => (
        { status: 'SUCCESS', members: res.data }
      ))
      .catch((err) => {
        this.logger.requestError(err);
        return {
          status: 'ERROR',
          members: [],
        };
      });
  }

  saveMembersToApp(appId: string = '', members: Array<MemberType> = []): Promise<Object> {
    if (!appId) {
      return Promise.reject({ err: 'No appId supplied' });
    }
    if (!members.length) {
      return Promise.reject({ err: 'No members supplied' });
    }
    return this.api.post(`${this.baseUrl}/application/${appId}/member`, { members })
      .then(res => (
        { status: 'SUCCESS', members: res.data }
      ))
      .catch((err) => {
        this.logger.requestError(err);
        return {
          status: 'ERROR',
          members: [],
        };
      });
  }

  deleteMember(id: string): Promise<HttpResponseType> {
    if (!id) {
      return Promise.reject({ err: 'No id supplied' });
    }
    const params = { id };
    return this.api.delete(`${this.baseUrl}/member`, { params });
  }
}
